document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.oa-testimonials')) {
		const testimonialsSwiper = new Swiper('.oa-testimonials .swiper', {
			slidesPerView: 1,
			spaceBetween: 100,
			grabCursor: true,
			loop: true,
			speed: 600,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			}
		});
	}
});
